import React from "react";
import PropTypes from "prop-types";

const StatsBar = ({ items, ...props }) => {
  const accessibleLabel = items.map(item => item.text).join(', ');

  return (
  <div
    className="slds-m-bottom_large th-agentforce-assessment__stats-bar"
    data-testid="stats-bar-container"
    role="img"
    tabIndex="0"
    aria-label={accessibleLabel}
    {...props}>
    {items.map((item, index) => (
      <React.Fragment key={`${item.icon}-${item.text}`}>
        {index > 0 && <div className="th-agentforce-assessment__stats-divider" data-testid="stat-divider"></div>}
        <div
          className="th-agentforce-assessment__stat-item"
          style={{ color: item.color || 'var(--tds-color-midnight)' }}
          data-testid="stat-item">
          <tds-icon symbol={item.icon} sprite={item.sprite || 'utility'} size="medium" aria-hidden="true"></tds-icon>
          <span className="slds-text-body_regular slds-text-title_bold">
            {item.text}
          </span>
        </div>
      </React.Fragment>
    ))}
  </div>
  );
};

StatsBar.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      sprite: PropTypes.string,
      text: PropTypes.string.isRequired,
      color: PropTypes.string,
    })
  ).isRequired,
};

export default StatsBar;
